var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import axios from "axios";
import { ErrorsTypes } from "./errors.constants";
import { ModalBase, Button } from "../../../../components";
import MailIcon from "../../../../assets/icons/mail.svg";
import { ENV } from "../../../../config/env";
var RequalificationModal = function (props) {
    var clientId = props.clientId, document = props.document, onError = props.onError, onSuccess = props.onSuccess, isOpen = props.isOpen;
    var _a = useState(false), loading = _a[0], setLoading = _a[1];
    function handleSubmit() {
        var _a, _b, _c;
        return __awaiter(this, void 0, Promise, function () {
            var data, e_1, errorResponse, errorType;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        event.preventDefault();
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, , 4]);
                        setLoading(true);
                        return [4 /*yield*/, axios.post("".concat(ENV.LOGIN_URL, "/send-requalification-email"), {
                                document: document,
                                clientId: clientId,
                            })];
                    case 2:
                        data = (_d.sent()).data;
                        onSuccess();
                        setLoading(true);
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _d.sent();
                        setLoading(!true);
                        errorResponse = (_b = (_a = e_1 === null || e_1 === void 0 ? void 0 : e_1.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error;
                        errorType = (_c = ErrorsTypes[errorResponse]) !== null && _c !== void 0 ? _c : ErrorsTypes["InternalServerError"];
                        onError(errorType);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    return (_jsx(ModalBase, { isOpen: isOpen, content: _jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "title" }, { children: _jsx("h2", { children: "Identificamos que seu documento tem mais de um cadastro!" }) })), _jsx("div", __assign({ className: "icon" }, { children: _jsx("img", { src: MailIcon, width: "179", height: "92", alt: "e-mail" }) })), _jsx("p", { children: "Recentemente, atualizamos a nossa pol\u00EDtica de seguran\u00E7a para otimizar a privacidade dos seus dados de sa\u00FAde." }), _jsx("br", {}), _jsx("br", {}), _jsx("p", { children: "Por isso, vamos enviar e-mails para unificar todos os cadastros vinculados ao seu documento" })] }), bottomContent: _jsx(Button, __assign({ loading: !!loading, onClick: handleSubmit }, { children: "OK" })) }));
};
export default RequalificationModal;
